module.exports = __webpack_public_path__ + "static/media/like2.14cb8e5c.gif";